import Head from "next/head";
import { GetStartedScreen } from "@medbillai/app/screens/auth/get-started/get-started";
import { SignUpOnboardingLayout } from "@medbillai/app/screens/sign-up-onboarding/layout.web";
import { SlidingLayout } from "../utils/transition/SlidingLayout";
import type { NextPageWithLayout } from "./_app";
export const Page: NextPageWithLayout = () => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="get-started.tsx">
        <title>Get Started</title>
      </Head>
      <GetStartedScreen data-sentry-element="GetStartedScreen" data-sentry-source-file="get-started.tsx" />
    </>;
};
Page.getLayout = page => <SignUpOnboardingLayout maxWidth={600}>
    <SlidingLayout>{page}</SlidingLayout>
  </SignUpOnboardingLayout>;
export default Page;